import React, { useImperativeHandle, useState } from "react";
import { ModalSubmit, Spinner, MultiSelect } from "components/common";
import { Alert, Modal } from "components/bootstrap";
import useStreamCategories from "illuminate/hooks/useStreamCategories";
import useStreamCategoryMutation from "illuminate/hooks/useStreamCategoryMutation";
const StreamCategoriesModal = React.forwardRef(
  ({ entity: stream, entityType, onClose = void 0 }, ref) => {
    const [showModal, setShowModal] = useState(false);
    const [selectedCategories, setSelectedCategories] = useState("");
    const { categories: streamCategories, isLoading: loadingCategories } = useStreamCategories(showModal);
    const { updateCategories } = useStreamCategoryMutation();
    useImperativeHandle(ref, () => ({
      toggle: () => {
        var _a;
        setSelectedCategories(((_a = stream.categories) != null ? _a : []).join(","));
        setShowModal(true);
      }
    }));
    const closeModal = () => {
      setShowModal(false);
      if (onClose) onClose();
    };
    const categoryOptions = streamCategories.map((category) => ({
      value: category,
      label: category
    }));
    const handleSubmit = () => {
      const categories = selectedCategories ? selectedCategories.split(",") : [];
      updateCategories.mutate({ streamId: stream.id, categories }, { onSuccess: closeModal });
    };
    if (entityType !== "stream") {
      return null;
    }
    return /* @__PURE__ */ React.createElement(Modal, { onHide: closeModal, show: showModal }, /* @__PURE__ */ React.createElement(Modal.Header, { showCloseButton: true }, /* @__PURE__ */ React.createElement(Modal.Title, null, "Manage Stream Categories for \u201C", stream.title, "\u201D")), /* @__PURE__ */ React.createElement(Modal.Body, null, loadingCategories ? /* @__PURE__ */ React.createElement(Spinner, { text: "Loading categories..." }) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, "Select stream categories to associate with this stream."), /* @__PURE__ */ React.createElement(
      MultiSelect,
      {
        id: "stream-categories-select",
        placeholder: "Select stream categories...",
        options: categoryOptions,
        value: selectedCategories,
        onChange: (value) => setSelectedCategories(value),
        allowCreate: true
      }
    ))), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
      ModalSubmit,
      {
        submitButtonText: "Update categories",
        submitLoadingText: "Updating categories...",
        onCancel: closeModal,
        isAsyncSubmit: true,
        isSubmitting: updateCategories.isPending,
        onSubmit: handleSubmit,
        submitButtonType: "button"
      }
    )));
  }
);
export default StreamCategoriesModal;
